import React, { useEffect, useState } from "react";

const AdminFields = () => {
  const [projects, setProjects] = useState([]);
  const [fields, setFields] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const [label, setLabel] = useState("");
  const [type, setType] = useState("number");
  const [order, setOrder] = useState(0);

  const fetchProjects = async () => {
    const res = await fetch("/api/projects");
    const data = await res.json();
    setProjects(data);
    if (data.length > 0) {
      console.log("Initial project ID:", data[0]._id);
      setSelectedProject(data[0]._id);
    }
  };

  const fetchFields = async (projectId) => {
    const res = await fetch("/api/fields");
    const data = await res.json();
    const filtered = data.filter(f => f.projectId === projectId);
    console.log("Fields for project:", projectId, filtered);
    setFields(filtered);
  };

  const handleCreateField = async (e) => {
    e.preventDefault();
    if (!selectedProject || !label) {
      alert("Missing project or label");
      return;
    }

    console.log("Creating field for project:", selectedProject);

    const res = await fetch("/api/fields", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ label, type, order, projectId: selectedProject }),
    });

    const data = await res.json();

    if (!res.ok) {
      alert(data.message || "Failed to create field");
      return;
    }

    setLabel("");
    setType("number");
    setOrder(0);
    fetchFields(selectedProject);
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  useEffect(() => {
    if (selectedProject) fetchFields(selectedProject);
  }, [selectedProject]);

  return (
    <div className="max-w-3xl mx-auto p-8 bg-gray-50 min-h-screen">
      <div className="bg-white rounded-2xl shadow-lg p-8 mb-10 border border-gray-100">
        <h2 className="text-3xl font-bold mb-6 text-[#173861] tracking-tight">⚙️ Field Manager</h2>

        <label className="block mb-3 font-medium text-lg">Select Project:</label>
        <select
          className="w-full border p-3 mb-6 rounded-lg text-lg focus:ring-2 focus:ring-[#173861] focus:outline-none"
          value={selectedProject}
          onChange={(e) => setSelectedProject(e.target.value)}
        >
          {projects.map((p) => (
            <option key={p._id} value={p._id}>
              {p.name}
            </option>
          ))}
        </select>

        <form onSubmit={handleCreateField} className="space-y-4 mb-8">
          <input
            type="text"
            placeholder="Field label"
            className="w-full p-3 border rounded-lg text-lg focus:ring-2 focus:ring-[#173861] focus:outline-none"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            required
          />
          <select
            className="w-full p-3 border rounded-lg text-lg focus:ring-2 focus:ring-[#173861] focus:outline-none"
            value={type}
            onChange={(e) => setType(e.target.value)}
          >
            <option value="number">Number</option>
            <option value="text">Text</option>
          </select>
          <input
            type="number"
            placeholder="Order"
            className="w-full p-3 border rounded-lg text-lg focus:ring-2 focus:ring-[#173861] focus:outline-none"
            value={order}
            onChange={(e) => setOrder(Number(e.target.value))}
          />
          <button className="bg-blue-600 text-white px-6 py-3 rounded-lg font-bold text-lg hover:bg-blue-700 shadow transition">
            Add Field
          </button>
        </form>

        <h3 className="text-2xl font-semibold mb-4 text-[#173861]">Fields for Project</h3>
        <ul className="space-y-3">
          {fields.map((f) => (
            <li key={f._id} className="border p-4 rounded-lg bg-gray-50 text-lg">
              <strong>{f.label}</strong>{' '}
              <span className="text-base text-gray-500">({f.type})</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AdminFields;
